import SourceRenderer from "../../../../../../lib/source/SourceRenderer";
import HtmlUtils from "../../../../../../lib/source/HtmlUtils";

export function sourceSetContent(editor, e) {
  const $ = editor.dom.$;
  $('script', e.node).each((idx, elm) => {
    let renderer = new SourceRenderer($(elm));
    elm.outerHTML = renderer.render();
  });
}

export function sourcePreProcess(editor, e) {
  const $ = editor.dom.$;
  $('div[data-ke-type="source"]', e.node).each((idx, elm) => {
    elm.outerHTML = HtmlUtils.urlDecode($(elm).attr('data-source'));
  });
}
